import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "wrapped-text",
  templateUrl: "wrapped-text.html",
})
export class WrappedTextComponent implements OnInit {
  @Input() textArray: Array<string>;
  @Input() text = "";
  @Input() otherText: string;
  @Input() textLength: number;
  concatenatedText: string = "";
  showMore = false;
  ngOnInit(): void {
    if (this.text) {
      this.concatenatedText = this.text;
    } else if (this.textArray && !Array.isArray(this.textArray)) {
      this.concatenatedText = this.textArray;
    } else {
      let tempCategories: Array<string> = [];
      if (this.textArray) {
        tempCategories = this.textArray.filter(
          (category) => category.toLowerCase() !== "other"
        );
      }
      if (this.otherText) {
        tempCategories.push(this.otherText);
      }
      this.concatenatedText = tempCategories
        .filter((category) => category !== "")
        .map((category) => this.translatePipe.instant(category))
        .join(", ");
    }
  }

  constructor(public translatePipe: TranslateService) {}

  trimString(string, length) {
    return string.length > length
      ? string.substring(0, length) + "..."
      : string;
  }
}



// WEBPACK FOOTER //
// ./src/components/order-management/om-details/wrapped-text/wrapped-text.ts